import { Link } from "react-router-dom";
import { brand } from "@/data/site";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="mt-16 border-t border-[color:var(--wx-line)] bg-white"
        >
            <div className="wx-container py-10">
                <div className="text-xl font-extrabold tracking-tight text-[color:var(--wx-ink)]">
                    WxFaous
                </div>
                <p className="mt-3 text-xs text-[color:var(--wx-muted)]">
                    WxFaous is operated by {brand.legal}.
                </p>

                <div className="mt-6 grid gap-6 sm:grid-cols-2">
                    <div>
                        <p className="wx-eyebrow">Alamat Bisnis</p>
                        <address className="mt-2 not-italic text-sm text-[color:var(--wx-ink2)] leading-relaxed">
                            {brand.address.line1}
                            <br />
                            {brand.address.line2}
                            <br />
                            {brand.address.city}, {brand.address.province}{" "}
                            {brand.address.postal}
                            <br />
                            {brand.address.country}
                        </address>
                    </div>
                    <div>
                        <p className="wx-eyebrow">Kontak</p>
                        <ul className="mt-2 space-y-1 text-sm text-[color:var(--wx-ink2)]">
                            <li>
                                <a
                                    href={`mailto:${brand.email}`}
                                    className="hover:text-[color:var(--wx-blue)]"
                                >
                                    {brand.email}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`tel:+${brand.phoneRaw}`}
                                    className="hover:text-[color:var(--wx-blue)]"
                                >
                                    {brand.phone}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-6 flex flex-wrap gap-x-5 gap-y-2 text-xs">
                    <Link
                        to="/tentang-kami"
                        className="text-[color:var(--wx-muted)] hover:text-[color:var(--wx-ink)]"
                    >
                        Tentang Kami
                    </Link>
                    <Link
                        to="/kontak"
                        className="text-[color:var(--wx-muted)] hover:text-[color:var(--wx-ink)]"
                    >
                        Kontak
                    </Link>
                    <Link
                        to="/kebijakan-privasi"
                        className="text-[color:var(--wx-muted)] hover:text-[color:var(--wx-ink)]"
                    >
                        Kebijakan Privasi
                    </Link>
                </div>

                <p className="mt-6 text-[11px] text-[color:var(--wx-muted)]">
                    © {new Date().getFullYear()} {brand.legal}. Seluruh hak
                    cipta dilindungi.
                </p>
            </div>
        </footer>
    );
}
